import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {copy, randomNumber, searchEmJSON} from 'react-lf-tools'
import {getLocal, getSession} from '../../hooks/useStorage/useStorage.jsx'
import {Snackbar} from '@mui/material'
import {getConsultation, sendPayment} from '../../services/Apis.jsx'
import {colors, getMode} from '../../utils/utils.jsx'
import {getDatabase, onValue, ref} from 'firebase/database'

import {consultation as textsConsultation, general as textsGeneral} from '../../translate/Translate.jsx'
import app from '../../services/firebase.js'

import Header from '../../components/header/Header.jsx'
import Scan from '../../components/scan/Scan.jsx'
import DescriptionConsultation from './descriptionValues/DescriptionConsultation.jsx'
import ConsultationBuyButton from './consultationBuyButton/ConsultationBuyButton.jsx'
import {
    DialogAddCardCredit,
    DialogAddCard,
    DialogLoading,
    DialogPaymentMethods,
    DialogPix,
    DialogWarning,
    DialogSuccessPayment
} from '../../components/dialogs/Dialogs.jsx'

import './consultation.scss'
import {ThemeProvider} from "@mui/material/styles"
import themeMui from '../../themeMui.jsx'

import {motion} from 'framer-motion'

import {tokenizeCard} from '../../utils/utils.jsx'

const Consultation = () => {
    const navigate = useNavigate()
    const transactionID = randomNumber(15)
    const [cards, setCards] = useState([])
    const [scan, setScan] = useState(false)
    const [dataConsultation, setDataConsultation] = useState({})
    const [dialogWarning, setDialogWarning] = useState({
        open: false,
        title: '',
        message: ''
    })
    const [dialogAddCardCredit, setDialogAddCardCredit] = useState({
        open: false
    })
    const [dialogPaymentMethods, setDialogPaymentMethods] = useState({
        open: false
    })
    const [dialogPix, setDialogPix] = useState({
        open: false,
        qrcode: '',
        value: 0
    })
    const [dialogAddCard, setDialogAddCard] = useState({
        open: false
    })
    const [dialogLoading, setDialogLoading] = useState({
        open: false,
        message: ''
    })
    const [dialogSuccessPayment, setDialogSuccessPayment] = useState({
        open: false,
        nfe: ''
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [viewScan, setViewScan] = useState(false)

    const handleCloseSnackbar = () => setSnackbar({open: false})

    const handleClickSuccessPayment = (nfe) => {
        setDialogSuccessPayment({...dialogSuccessPayment, open: false})
        navigate(-1)
        if (nfe) window.location.assign(nfe)
    }

    const handleClickWarning = () => setDialogWarning({...dialogWarning, open: false})

    const handleClickScan = () => {
        setViewScan(false)
        setScan(true)
    }

    const handleCloseAddCard = () => {
        setDialogAddCard({open: false})
        setViewScan(true)
        setCards([])
    }

    const handleCloseAddCardCredit = () => {
        setDialogAddCardCredit({open: false})
    }

    const handleClickAddCardCredit = async () => {
        setDialogAddCardCredit({open: false})
        const payment = getSession('payment')
        const card = getSession('card') || null
        if (card === null) return
        const table = getSession('table', '')
        const comandas = getMode() === 'mesa' ? [parseInt(table)] : [parseInt(cards)]
        const json = {
            pagamento: {
                authkey: getLocal('authkey'),
                id_loja: getLocal('idStore'),
                ccc: tokenizeCard(card, transactionID),
                codigo: code(payment),
                bandeira: card.type.toUpperCase(),
                comandas: comandas,
                valorPago: dataConsultation.total,
                tipo_pedido: getMode(),
                transactionID: transactionID
            }
        }
        setDialogLoading({open: true, message: 'Enviando pagamento...'})
        const response = await sendPayment(json)
        if (!!response.returnCode) {
            setDialogLoading({open: true, message: 'Realizando pagamento...'})
            statusPaymentCredit(transactionID)
        } else {
            setDialogWarning({open: true, title: 'Erro!', message: response.message})
        }
    }

    const code = payment => {
        if (payment.description.toLowerCase() === 'pagamento online') {
            const card = getSession('card', {})
            const paymentTypes = getLocal('paymentTypes', [])
            for (let i = 0; paymentTypes.length; i++) {
                if ((paymentTypes[i].online === 'True') && (paymentTypes[i].description.toUpperCase().includes(card.type.toUpperCase()))) {
                    return paymentTypes[i].code
                }
            }
        }
        return payment.code
    }

    const handleClickAdd = () => {
        setDialogAddCard({open: false})
        handleClickScan()
    }

    const handleClickPay = () => {
        setDialogPaymentMethods({open: true})
    }

    const handleClickRemove = card => setCards(cards.filter(c => c !== card))

    const handleClickConsult = () => {
        setDialogAddCard({open: false})
        consultation(cards)
    }

    const handleClosePaymentMethods = () => {
        setDialogPaymentMethods({open: false})
    }

    const handleClickPaymentMethods = async (payment) => {
        if (payment.code === 'ONLINE') {
            setDialogAddCardCredit({open: true})
            setDialogPaymentMethods({open: false})
            return
        }
        handleClosePaymentMethods()
        const mode = getMode()
        const table = getSession('table', '')
        let comandas = (mode === 'mesa') ? [parseInt(table)] : cards
        setDialogLoading({
            open: true,
            message: 'Gerando PIX..'
        })
        const response = await getConsultation(payment.code === 'PIX', comandas, mode, transactionID)
        setDialogLoading({open: false})
        if (!response.returnCode) return setDialogWarning({
            open: true,
            message: response.message
        })
        checkPIX(transactionID)
    }

    const handleClosePix = () => {
        setDialogPix({open: false})
    }

    const handleClickPix = async (pix) => {
        const response = await copy(pix)
        setSnackbar({open: true, message: response})
    }

    const handleResult = ({text}) => {
        try {
            if (!text) return setSnackbar({
                open: true,
                message: textsGeneral.scanReadingError
            })
            if (text.includes('http'))
                qrCode(text)
            else
                barCode(text)
        } catch (e) {
            setSnackbar({open: true, message: e.message})
        } finally {
            setScan(false)
        }
    }

    const qrCode = qrCode => {
        qrCode = qrCode.substring(qrCode.indexOf('?') + 1)
        qrCode = atob(qrCode)
        qrCode = searchEmJSON(qrCode, 0)
        const cardNumber = parseInt(qrCode.cartao, 10)
        if (!cards.includes(cardNumber)) {
            setCards([...cards, cardNumber])
        }
        setDialogAddCard({open: true})
    }

    const barCode = barCode => {
        const cardNumber = parseInt(barCode, 10)
        if (!cards.includes(cardNumber)) {
            setCards([...cards, cardNumber])
        }
        setDialogAddCard({open: true})
    }

    const handleError = (error) => setDialogWarning({
        open: true,
        message: error
    })

    const handleCancel = () => {
        setScan(false)
        setViewScan(true)
        setCards([])
    }

    const checkConsultation = (transactionID) => {
        const starCountRef = ref(getDatabase(app), `logs/${import.meta.env.VITE_AUTHKEY}/${transactionID}/consulta/retorno`)
        onValue(starCountRef, (snapshot) => {
            const data = snapshot.val()
            if (!data) return
            if (data?.sucesso) {
                setDataConsultation(data)
            } else {
                setDialogWarning({
                    open: true,
                    title: textsGeneral.warning,
                    message: (data?.mensagem || '') === 'Pago - ' ? 'Essa conta já está paga!' : data?.mensagem || ''
                })
            }
        })
    }

    const checkPIX = (transactionID) => {
        setDialogLoading({open: true, message: 'Buscando dados..'})
        const starCountRef = ref(getDatabase(app), `logs/${import.meta.env.VITE_AUTHKEY}/${transactionID}/consulta/retorno`)
        onValue(starCountRef, (snapshot) => {
            setDialogLoading({open: false})
            const data = snapshot.val()
            if (!data) return
            if (data?.qrcode) setDialogPix({
                open: true,
                qrcode: data.qrcode,
                value: data.pixValor
            })
            statusPIX(data.txid)
        })
    }

    const statusPIX = (txid) => {
        const starCountRef = ref(getDatabase(app), `logs/${import.meta.env.VITE_AUTHKEY}/${txid}/pagamento/retorno`)
        onValue(starCountRef, (snapshot) => {
            const data = snapshot.val()
            if (!data) return
            if (data?.sucesso) {
                setDialogPix({...dialogPix, open: false})
                setDialogSuccessPayment({open: true})
            } else {
                setDialogPix({...dialogPix, open: false})
                setDialogWarning({open: true, title: 'Erro!', message: data.mensagem})
            }
        })
    }

    const statusPaymentCredit = (txid) => {
        const starCountRef = ref(getDatabase(app), `logs/${import.meta.env.VITE_AUTHKEY}/${txid}/pagamento/retorno`)
        onValue(starCountRef, (snapshot) => {
            const data = snapshot.val()
            if (!data) return
            if (data?.sucesso) {
                setDialogSuccessPayment({open: true, nfe: data?.nfe || ''})
                setDialogLoading({...dialogLoading, open: false})
            } else {
                setDialogWarning({open: true, title: 'Erro!', message: data?.mensagem})
                setDialogLoading({...dialogLoading, open: false})
            }
        })
    }

    const checkModeOperation = async () => {
        const mode = getSession('mode')
        if (mode === 'table') {
            const table = getSession('table', '')
            consultation([parseInt(table)])
        } else {
            setScan(true)
        }
    }

    const consultation = async arr => {
        try {
            const mode = getMode()
            setDialogLoading({open: true, message: textsConsultation.consulting})
            const {returnCode} = await getConsultation(false, arr, mode, transactionID)
            if (!!returnCode) checkConsultation(transactionID)
        } finally {
            setDialogLoading({...dialogLoading, open: false})
        }
    }

    useEffect(() => {
        setTimeout(() => checkModeOperation(), 400)
    }, [])

    if (scan) return <Scan
        onResult={handleResult}
        onError={handleError}
        onCancel={handleCancel}/>

    const styles = getLocal('colors')

    colors(document)

    return <ThemeProvider theme={themeMui(styles)}>
        <motion.div
            className={'consultation'}
            initial={{x: -400}}
            animate={{x: 0}}
            transition={{duration: 0.3}}>
            <Header title={textsConsultation.consultation} buttonBack={true}/>
            <div className={'container-consultation'}>
                <DescriptionConsultation
                    data={dataConsultation}
                    viewScan={viewScan}
                    onClick={handleClickScan}/>
                <ConsultationBuyButton
                    data={dataConsultation}
                    onClick={handleClickPay}/>
            </div>
            <>
                <DialogAddCard
                    open={dialogAddCard.open}
                    cards={cards}
                    onClose={handleCloseAddCard}
                    onClickAdd={handleClickAdd}
                    onClickRemove={handleClickRemove}
                    onClickConsult={handleClickConsult}
                />
                <DialogPaymentMethods
                    open={dialogPaymentMethods.open}
                    onClose={handleClosePaymentMethods}
                    onClick={handleClickPaymentMethods}
                />
                <DialogPix
                    open={dialogPix.open}
                    qrcode={dialogPix.qrcode}
                    value={dialogPix.value}
                    onClose={handleClosePix}
                    onClick={handleClickPix}
                />
                <DialogAddCardCredit
                    open={dialogAddCardCredit.open}
                    onClose={handleCloseAddCardCredit}
                    onClick={handleClickAddCardCredit}
                />
                <DialogLoading
                    open={dialogLoading.open}
                    message={dialogLoading.message}/>
                {dialogSuccessPayment.open && <DialogSuccessPayment
                    open={dialogSuccessPayment.open}
                    nfe={dialogSuccessPayment.nfe}
                    onClick={handleClickSuccessPayment}
                />}
                <DialogWarning
                    open={dialogWarning.open}
                    title={dialogWarning.title}
                    message={dialogWarning.message}
                    onClick={handleClickWarning}
                />
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={1600}
                    onClose={handleCloseSnackbar}
                    message={snackbar.message}/>
            </>
        </motion.div>
    </ThemeProvider>
}

export default Consultation
